import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParticipantesComponent } from './participantes.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { ParticipantesEditComponent } from './participantes-edit/participantes-edit.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
  ],
  declarations: [ParticipantesComponent, ParticipantesEditComponent]
})
export class ParticipantesModule { }
